<div
  class="mt-4 notice-box-in-warranty"
  *ngIf="showInWarrantyNotice && !isIWEnabled"
>
  <ng-container *ngIf="inWarrantyContactInfoAvailable; else defaultLayout">
    <div class="warranty-text">
      <h2>Please call {{ claim?.getData?.BookingOEM }}</h2>
      <p>
        Your {{ productType }} is still within its
        {{ claim?.getData?.BookingOEM }} guarantee, which covers breakdowns.
      </p>
      <p>To arrange your repair, you can call:</p>
    </div>

    <p class="typog-body-bold">Phone <br /></p>
    <section class="phone-line-wrapper mb-5">
      <dgx-components-icon name="phone" size="sm"></dgx-components-icon>

      <a
        class="typog-body-large-bold"
        *ngIf="InWarrantyContactTel"
        href="tel:{{ InWarrantyContactTel }}"
        >{{ InWarrantyContactTel }}</a
      >

      <span *ngIf="!InWarrantyContactTel">their direct line.</span>
    </section>
  </ng-container>
  <ng-template #defaultLayout>
    <div class="warranty-text">
      <h2>Your appliance is still under warranty</h2>
      <p>Please contact the manufacturer to book a repair.</p>
    </div>
  </ng-template>

  <dgx-components-button
    type="submit"
    variant="primary"
    iconName="arrow-right"
    data-automation="'backToPlanDetails'"
    (click)="routeToDashBoard.emit()"
    class="button-default"
  >
    Back to dashboard
  </dgx-components-button>
</div>

<div *ngIf="showplanInWaitPeriodNotice && !isIWEnabled" class="mt-4">
  <div class="notice-box">
    <h4>
      You can’t book a repair because you’re still within the wait period of
      your plan.
    </h4>

    <p>
      Please check your terms and conditions to find out when you’ll be able to
      request a repair.
    </p>

    <dgx-components-button
      class="mt-4"
      type="submit"
      variant="primary"
      iconName="arrow-right"
      data-automation="'backToPlanDetails'"
      (click)="routeToPlanDetails.emit()"
    >
      Back to Plan details
    </dgx-components-button>
  </div>
</div>

<div *ngIf="isIWEnabled" class="mt-4">
  <div class="notice-box iwEnabled">
    <h4>A faster way to get it fixed</h4>

    <p>
      To fix your appliance quickly and conveniently, we now offer repair
      callbacks for some faults.
    </p>

    <ul class="mb-6">
      <li>
        If your fault qualifies, you can book a callback with an expert before
        booking an engineer visit.
      </li>
      <li>
        On the call, an expert will guide you step by step to make a simple fix.
      </li>
      <li>
        If it isn't fixed, you'll get an engineer booking right away - so you've
        always got the help you need.
      </li>
    </ul>

    <dgx-components-button
      *ngIf="isIWEnabled"
      type="submit"
      variant="primary"
      iconName="arrow-right"
      data-automation="'ConfirmAD'"
      (click)="continueClicked.emit()"
    >
      Got it, let's continue
    </dgx-components-button>
  </div>
</div>
